export default __webpack_public_path__ + "static/media/emergency.43f176cc.png";